import React from 'react';

// Dog-eared note glyph for the lead-list sticky-note column, with an orange
// dot when the lead has a note.
//
// The state colour is a `color` PRESENTATION attribute rather than an inline
// `style` so it sits at the bottom of the cascade — that's what lets a
// `:hover` rule on the wrapping cell recolour the whole glyph.
const NoteIcon: React.FC<{ size?: number; hasNotes?: boolean }> = ({
    size = 24,
    hasNotes = false
}) => {
    const color = hasNotes ? 'var(--color-neutrals-textAlpha)' : 'var(--color-neutrals-textGamma)';

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            color={color}
            aria-hidden
            role="img"
        >
            <title>{hasNotes ? 'Lead has a sticky note' : 'No sticky note yet'}</title>

            <path
                d="M5.5 3.5H18.5C19.6 3.5 20.5 4.4 20.5 5.5V14.5L14.5 20.5H5.5C4.4 20.5 3.5 19.6 3.5 18.5V5.5C3.5 4.4 4.4 3.5 5.5 3.5Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />

            <path
                d="M20.5 14.5H16.5C15.4 14.5 14.5 15.4 14.5 16.5V20.5L20.5 14.5Z"
                fill="currentColor"
            />

            {['M7.6 9.4H11.2', 'M14.2 9.4H16.4', 'M7.6 12.6H15'].map((d) => (
                <path key={d} d={d} stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            ))}

            {hasNotes ? <circle cx="19" cy="5" r="5" fill="var(--color-primary-alpha)" /> : null}
        </svg>
    );
};

export default NoteIcon;
